<template>
  <div class="lg:px-16 md:px-12 px-5 lg:py-8 md:py-8 py-4 landing">
    <div class="">
      <p class="fsize32 sm-fsize24 font-semibold text-primary text-center">
        WHAT WE OFFER
      </p>

      <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 mt-8">
        <div
          class="p-4 cust-shadow1 rounded-md cursor-pointer"
          v-for="(item, index) in getServicesData"
          :key="index"
          @click="handleRedirect(item)"
        >
          <img
            :src="`${$imageURL}/${item.icon}`"
            alt="img"
            class="w-full h-48 object-cover"
          />

          <p
            class="fsize20 sm-fsize16 font-semibold text-black text-center mt-3"
          >
            {{ item.title }}
          </p>
        </div>
        <!-- <div class="p-4 cust-shadow1 rounded-md">
          <img
            src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
            alt="img"
            class="w-full h-48 object-cover"
          />

          <p
            class="fsize20 sm-fsize16 font-semibold text-black text-center mt-3"
          >
            Lorem ipsum dolor sit amet
          </p>
        </div>
        <div class="p-4 cust-shadow1 rounded-md">
          <img
            src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
            alt="img"
            class="w-full h-48 object-cover"
          />

          <p
            class="fsize20 sm-fsize16 font-semibold text-black text-center mt-3"
          >
            Lorem ipsum dolor sit amet
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      getServicesData: [],
    };
  },

  computed: {
    // ...mapState("auth", { user: "user" }),
    // ...mapState("respitecare", ["get_all_count", "allWithdrawalRequest"]),
  },

  methods: {
    async init() {
      const campID = this.$route.params;
      let payload = {
        selectedCampaigns: campID.id,
      };
      const getServices = await this.$store.dispatch(
        "services/get_all",
        payload
      );
      // console.log(getServices.data.result, "GET SERVICES");
      this.getServicesData = getServices.data.result;
    },
    async handleRedirect(item) {
      this.$store.commit("services/SELECTED_SERVICE_CARD", item);
      if (item.isURL) {
        window.open(`${item.link}?service=${item.title}`, "_blank");
      } else if (item.isScrollSF) {
        this.closeModal("modal-1");
        const el = document.getElementById("shopRegisterService");
        if (el == null || el == "null") {
          window.open(
            `${window.location.origin}/service-overview?service=${item.title}`,
            "_blank"
          );
        } else {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        window.open(
          `${window.location.origin}/service-overview?service=${item.title}`,
          "_blank"
        );
      }
    },
  },

  async mounted() {
    this.init();
  },
};
</script>
